import api from '@/api/api';

export default {
    obterConfig() {
        return api.get(route('certidoes.config'));
    },

    buscar(data) {
        return api.post(route('certidoes.buscar'), data);
    },

    emitir(data) {
        return api.post(route('certidoes.emitir'), data);
    },

    validar(codigo) {
        return api.post(route('certidoes.validar', { codigo }));
    },

    exigeCpfCnpj(data) {
        return api.post(route('certidoes.exige-cpf-cnpj'), data);
    }
};
